(function () {
    'use strict';

    angular
        .module('app')
        .controller('login', login);

    login.$inject = ['loginService', '$rootScope', '$state', 'hubFactory', '$localStorage', '$mdDialog', '$location', 'tmhDynamicLocale', '$timeout', '$injector', 'sessionTimeoutService', 'clientAuthService', '$sce'];

    function login(loginService, $rootScope, $state, hubFactory, $localStorage, $mdDialog, $location, tmhDynamicLocale, $timeout, $injector, sessionTimeoutService, clientAuthService, $sce) {
        /* jshint validthis:true */
        var vm = this;
        vm.inProcess = false;
        vm.time = '';
        vm.loginService = loginService;
        vm.title = 'login';
        vm.message = '';
        vm.localStorage = $localStorage;
        vm.credentials = {
            loginName: '',
            loginPassword: ''
        };
        vm.appVersion = "";


        console.log("login controller initialized");

        //get the application's version
        loginService.getAppVersion().then(function (version) {
            vm.appVersion = version;
        });

        //JM 9/7/16 always set auto login off, removed autologin for FCS.
        //$localStorage.userInfo.autoLogin = false;

        // Refresh of
        // http://localhost/Synergis.WebApp/#/login
        // causes this to run again.
        //
        // Look for URL Navigation parameters.
        //var paramObj = $location.search();
        //if (paramObj["fileId"] != undefined && paramObj["fileId"] != null) {
        //    console.log("URL Nav: Received fileId.");
        //    // Store that we are doing a URL Navigation.
        //    loginService.urlNavigationFileId = paramObj["fileId"];
        //    // If we are logged in, go straight to the results page.
        //    if (loginService.isLoggedIn().then(function (data) {
        //        console.log("URL Nav: Already logged in.");
        //        $state.go('layout.results');
        //    }));
        //}
        //if (paramObj["listId"] != undefined && paramObj["listId"] != null) {
        //    console.log("URL Nav: Received listId.");
        //    // Store that we are doing a URL Navigation.
        //    loginService.urlNavigationListId = paramObj["listId"];
        //    // If we are logged in, go straight to the results page.
        //    if (loginService.isLoggedIn().then(function (data) {
        //        console.log("URL Nav: Already logged in.");
        //        $state.go('layout.results');
        //    }));
        //}

        // ******************************************
        // Localization
        // ******************************************

        vm.cultureName = 'en-US';
        vm.availableLanguages = [];

        // UI Elements
        vm.loginIdPlaceholder = 'Login ID';
        vm.passwordPlaceholder = 'Password';
        vm.languageLabelText = 'Language';
        vm.enable
            = 'Enable Auto Login';
        vm.loginButtonText = 'OK';
        vm.copyright = 'Copyright 2017-2022 Synergis Technologies, LLC. All rights reserved.';
        vm.error = 'Error';
        vm.incorrectLogin = 'Incorrect Login';
        vm.usernameOrPwdIsIncorrect = 'The user name or password is incorrect';

        vm.alreadyTitle = "Adept Message";
        vm.alreadyContent = "Warning - operator is already logged on. <br/> Serious errors could result if two operators concurrently use the same Login ID.";
        vm.alreadyAria = "Operator Logged In";
        vm.alreadyContinue = "Continue";
        vm.alreadyCancel = "Cancel";

        // ***************************************************************************
        // BEGIN: Session Timeouts
        // ***************************************************************************
        vm.msgbox = {};
        vm.msgbox.visible = false;
        $timeout(function () {
            var bTimedOut = sessionTimeoutService.checkForTimedOut();
            if (bTimedOut) {
                // $rootScope.msgBoxShow("You have been logged out due to inactivity.", "Session Timeout");
                vm.msgbox.title = loginService.resourceStrings["SESSION_TIMEOUT_TITLE"]; // "Session Timeout";
                vm.msgbox.message = loginService.resourceStrings["SESSION_TIMEOUT_LOGGED_OUT"]; // "You have been logged out due to inactivity.";
                vm.msgbox.visible = true;
            }
        }, 2000);
        // ***************************************************************************
        // END: Session Timeouts
        // ***************************************************************************


        // Pull default here. Browser language or cookie.
        // vm.cultureName = PULL 

        vm.cultureChanged = function () {
            vm.loginService.getResourceStrings(vm.cultureName).then(function (data) {
                // UI Elements
                vm.loginIdPlaceholder = data['LOGIN_PLACEHOLDER'];
                vm.passwordPlaceholder = data['PASSWORD_PLACEHOLDER'];
                vm.languageLabelText = data['LANGUAGE'];
                vm.enableAutoLogin = data['ENABLE_AUTO_LOGIN'];
                vm.loginButtonText = data['OK'];
                vm.copyright = data['COPYRIGHT'];
                vm.error = data['ERROR'];
                vm.incorrectLogin = data['INCORRECT_LOGIN'];
                vm.usernameOrPwdIsIncorrect = data['USERNAME_OR_PWD_IS_INCORRECT'];
                vm.loginBoxHeader = data['LOGIN_BOX_HEADER'];
                vm.appVersionTitle = data['VERSION'];
                vm.alreadyTitle = data["ADEPT_MESSAGE"]; // "Adept Message"
                vm.alreadyContent = data["ALREADY_LOGGED_IN_FULL_ONE"] + " <br/> " + data["ALREADY_LOGGED_IN_FULL_TWO"]; // "Warning - operator is already logged on. <br/> Serious errors could result if two operators concurrently use the same Login ID."
                vm.alreadyAria = data["ALREADY_LOGGED_IN"]; // "The user is already logged in." // "Operator Logged In"
                vm.alreadyContinue = data["CONTINUE"]; // "Continue"
                vm.alreadyCancel = data["CANCEL"]; // "Cancel"

                //set angular's locale
                tmhDynamicLocale.set(vm.cultureName.toLowerCase());

                vm.loginService.cultureName = vm.cultureName; // 2016-10-04
            });
        }

        // Call the service to populate the combo.
        vm.loginService.getAvailableLanguages().then(function (data) {
            var savedCultureName = vm.loginService.currentCultureName;
            if (savedCultureName == null || savedCultureName.length < 1)
                savedCultureName = "en-US";
            var bSet = false;
            //var bFirst = true;
            for (var cultureName in data) {
                vm.availableLanguages.push({ id: cultureName, name: data[cultureName] });
                // 2016-10-04
                //if (bFirst) {
                // For now, use the first one as the default.
                //vm.cultureName = cultureName;
                //vm.cultureChanged(); // Load with the correct initial language.
                //bFirst = false;
                //}
                if (cultureName == savedCultureName) {
                    bSet = true;
                    vm.cultureName = cultureName;
                    vm.cultureChanged();
                }
            }
            // catch all if stored lang was not found
            if (!bSet) {
                vm.cultureName = "en-US";
                vm.cultureChanged();
            }
        });


        // ******************************************
        //
        // ******************************************

        vm.logIn = function (forceLogin) {
            //hide msgBox
            $rootScope.msgBoxClosed();

            vm.inProcess = true;
            vm.clientAuthProcessError = false;

            loginService.getAuthenticationMode().then(function (data) {
                //console.log("authentication mode is: ", data);
                if (data === "eNameMatchesWindowsAndAdept" && bowser.windows) {
                    vm.clientAuthProcess = true;
                    clientAuthService.getLocalUser().then(function (data) {
                        vm.clientAuthProcess = false;
                        doLogin(forceLogin, data.windowsLogin, data.windowsDomain);
                    }, function () {
                        vm.clientAuthProcess = false;
                        vm.inProcess = false;
                        vm.clientAuthProcessError = true;
                    });
                }
                else {
                    doLogin(forceLogin);
                }
            });


            function doLogin(forceLogin, windowsLogin, windowsDomain) {
                var params = {
                    username: vm.credentials.loginName,
                    password: vm.credentials.loginPassword,
                    grant_type: "password",

                }

                vm.credentials.windowsLogin = windowsLogin;
                vm.credentials.windowsDomain = windowsDomain;

                var promise = loginService.logIn(vm.credentials, forceLogin, vm.cultureName);

                promise.then(function (data, status, headers, config) {
                    var handler = $injector.get('errorHandler');
                    handler.errors = [];
                    if (loginService.goToState) {
                        $state.go(loginService.goToState);
                        loginService.goToState = undefined;
                    }
                    else {
                        $state.go("layout.home");
                    }

                }, function (response) {
                    if (response.data.error == "user_loggedin") {
                        vm.showConfirm();
                    }
                    else {
                        vm.inProcess = false;
                    }
                });
            }
        };

        //controller for dialog
        var dialogController = function ($scope, $mdDialog, loginService) {
            $scope.loginService = loginService;
            $scope.hide = function () {
                $mdDialog.hide();
            };
            $scope.cancel = function () {
                $mdDialog.cancel();
            };
            $scope.answer = function (answer) {
                $mdDialog.hide(answer);
            };
        }


        vm.showConfirm = function (ev) {

            $mdDialog.show({
                controller: dialogController,
                templateUrl: 'app/login/templates/loginwarning.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                fullscreen: false
            })
                .then(function (answer) {
                    vm.logIn(true);
                }, function () {
                    //cancel
                    vm.inProcess = false;
                });
        }

        vm.showLocalStorage = function (ev) {
            //console.log("Hello");

            $mdDialog.show({
                controller: lsDialogController,
                templateUrl: 'app/login/templates/lssettings.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                fullscreen: false
            })
                .then(function (answer) {
                    vm.logIn(true);
                }, function () {
                    //cancel
                    vm.inProcess = false;
                });
        }

        var lsDialogController = function ($scope, $mdDialog, loginService, $timeout) {
            $scope.loginService = loginService;
            $scope.clearDisabled = false;
            $scope.hide = function () {
                $mdDialog.hide();
            };
            $scope.cancel = function () {
                $mdDialog.cancel();
            };
            $scope.clearLocalStorage = function (answer) {
                $scope.clearDisabled = true;
                localStorage.clear();
                location.reload();
            };
        }

    }
})();


